import { ComponentStylesWithFns } from '../../../theme/styles.helpers';

export const Styles: ComponentStylesWithFns = {
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    backgroundColor: 'primary.main',
    marginLeft: 5,
    borderRadius: '10px',
  },
  details: {
    display: 'flex',
    width: '100%',
    height: 'calc(100% - 60px)',
  },
  header: {
    display: 'flex',
    padding: 3,
    backgroundColor: 'white',
    borderBottom: '0.5px solid',
    borderColor: 'grey.200',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  leftContainer: {
    flex: 1,
    overflow: 'auto',
    height: '100%',
    padding: 4,
  },
  rightContainer: {
    width: '43%',
    padding: 4,
    backgroundColor: 'white',
    borderLeft: '0.5px solid',
    borderColor: 'grey.200',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    justifyContent: 'space-between',
    overflow: 'auto',
  },
  button: {
    height: 40,
    paddingY: 2,
    lineHeight: 0,
    fontSize: 14,
  },
};
